<template>
    <v-text-field
        v-model="inputedValue" 
        clearable
        outlined
        :placeholder="placeholder"
        dense
        hide-details
        :type="type"
        background-color="white"
        class="text-field"
    ></v-text-field>
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: String,
    type:{
        type: String,
        default: "text",
    },
  },
  computed: {
    inputedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
<style scoped lang="scss">
.text-field ::v-deep input{
    font-size: 13px !important;
}
.text-field ::v-deep .v-input__slot{
    height: 36px !important;
    min-height: 36px !important;
}
.text-field ::v-deep .v-input__append-inner{
    margin-top: 3px!important;
}
</style>